import {Observable, Subject} from "rxjs";
import {DeepLink} from "@app/core/shared/domain/entities/deep-link";
import {DeepLinkMapper} from "@app/core/shared/infrastructure/mappers/deep-link.mapper";
import {Injectable} from "@angular/core";
import {GetIsMobileUseCase} from "@app/core/shared/application/get-is-mobile.use-case";
import {FirebaseDynamicLinks,} from '@pantrist/capacitor-firebase-dynamic-links';

/**
 * Service for handling mobile deep links in the application,
 * receiving deep link events and mapping incoming URLs to DeepLink objects.
 */
@Injectable()
export class UrlDeepLinkService {

    constructor(
        private getIsMobileUseCase: GetIsMobileUseCase,
    ) {
        this.listenDeepLinks();
    }

    private readonly FIREBASE_DYNAMIC_LINKS_EVENT_KEY = 'deepLinkOpen'

    private receivedDeepLinkSubject = new Subject<DeepLink>();
    readonly receivedDeepLink$ = this.receivedDeepLinkSubject.asObservable();

    private mapper = new DeepLinkMapper();


    /**
     * Emits a DeepLink when the app receives a deep link.
     */
    public getDeepLink(): Observable<DeepLink> {
        return this.receivedDeepLink$;
    }

    /**
     * Listen to the deep link event, and emit the deep link when it is received.
     * @private
     */
    public listenDeepLinks() {
        if (!this.getIsMobileUseCase.execute()) {
            return;
        }
        FirebaseDynamicLinks.addListener(this.FIREBASE_DYNAMIC_LINKS_EVENT_KEY, (data) => {
            const deepLink = this.mapper.mapUrlToDeepLink(data.url);
            if (deepLink == null) {
                return;
            }
            this.receivedDeepLinkSubject.next(deepLink);
        });

    }
}

